import { render, staticRenderFns } from "./OurCostumer.vue?vue&type=template&id=63e1bb23&"
import script from "./OurCostumer.vue?vue&type=script&lang=js&"
export * from "./OurCostumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports